/*eslint-disable react/display-name*/
import React, { useEffect, useState } from 'react';
import './style.scss';
import { Link } from '@sitecore-jss/sitecore-jss-react';

import clsx from 'clsx';

const AppHeaderMenu = ({ items, handleItemHover, handleItemBlur, activeItemIndex, i18n }) => (
  <div className="app-header-menu">
    {items.map((item, index) => {
      return (
        <HeaderMenuItem
          data={item.fields}
          key={index}
          onHover={() => handleItemHover(index)}
          onBlur={() => handleItemBlur()}
          isHovered={activeItemIndex === index}
          i18n={i18n}
        />
      );
    })}
  </div>
);

const HeaderMenuItem = ({ data, onHover, onBlur, isHovered, i18n }) => {
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      let parentItemToMatch;
      if (data?.sectionPrefixURL?.value) {
        parentItemToMatch = `${i18n?.language}${data?.sectionPrefixURL?.value}`;
      }
      setSelected(
        window?.location?.pathname
          ?.toLocaleLowerCase()
          ?.indexOf(parentItemToMatch?.toLocaleLowerCase()) > -1
      );
    }
  }, []);

  return (
    <div
      className={clsx(
        'app-header-menu-link-wrapper',
        (isHovered || selected) && 'app-header-menu-link-wrapper-hovered'
      )}
      onMouseEnter={onHover}
      onMouseLeave={onBlur}
    >
      {data.link?.value?.href ? (
        <Link field={data.link} className="app-header-menu-link" />
      ) : (
        <div className="app-header-menu-link">
          {data?.link?.value?.text || data?.title?.value || 'Temp'}
        </div>
      )}
    </div>
  );
};

export default AppHeaderMenu;
